<template>
  <div class="recent-posts container">
    <h2 class="h3">
      Recent Posts
    </h2>
    <div class="row">
      <div class="col col-8 main">
        <ArticleCard
          :article="most"
          size="lg"
        />
      </div>
      <div class="col col-4 subs">
        <ArticleCard
          v-for="sub in subs" :key="sub.id"
          :article="sub"
        />
      </div>
    </div>
    <FeaturedCategories
      v-if="categories.length"
      :results="categories"
    />
  </div>
</template>
<script>
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import ArticleCard from './ArticleCard';
import FeaturedCategories from './FeaturedCategories';

export default {
  components: {
    ArticleCard,
    FeaturedCategories,
  },
  props: {
    results: { type: Array, default: () => [], required: true },
    categories: { type: Array, default: () => [], required: true },
  },
  computed: {
    most() {
      return this.results[0];
    },
    subs() {
      return this.results.slice(1);
    },
  },
};
</script>
<style scoped lang="scss">
.recent-posts {
  margin-top: var(--spacing-100);
  margin-bottom: calc(var(--spacing-120) - 38px);

  a {
    color: inherit;
    display: block;
  }

  .h3 {
    border-bottom: 1px solid rgba(0, 12, 31, 0.12);
    margin: 0;
    padding-bottom: var(--spacing-16);
  }

  .main {
    padding-right: var(--spacing-40);
  }

  .subs {
    .sub {
      margin-bottom: var(--spacing-48);
    }
  }
}

@include bp($bp-mobile) {
  .recent-posts {
    margin-top: var(--spacing-36);

    .row {
      margin-left: 12px;
      margin-right: 12px;
    }

    .h3 {
      margin-bottom: 24px;
    }

    .main {
      padding-right: 12px;
    }

    .subs {
      margin-top: 36px;
    }
  }
}

@include bp($bp-tablet) {
  .recent-posts {
    .subs {
      margin-left: -12px;
      margin-right: -12px;
      display: flex;
      max-width: calc(100% + 24px);
      width: calc(100% + 24px);
      flex: 0 0 auto;
    }
  }
}
</style>
